export interface ErrorCode{
    errorStatusCode:number;
    errorRemarks:string;
    code:string;
}

export interface ApiError{
    tab:string;
    section:string;
    api:string;
    apiURL:string;
    errorStatus:string;
    errorStatusCode:number;
    errorCode:string;
    errorMessage:string;
}

export interface ApiSectionMap{
    tab:string;
    subTab:string[];
    section:string;
    apiList:string[];
}


export const ApiSecMapping:ApiSectionMap[]=[
    
    {
        tab:'all',
        subTab:[],
        section:'common',
        apiList:[
            'picklistCategories',
            'getAllProductionEntityList',
            // 'getAllUnSynchedInterplanTitles'
        ]
    },

    {
        tab:'admin',
        subTab:['system-admin','audit-logs','manage-user','manage-release-date'],
        section:'admin',
        apiList:[]
    },
    {
        tab:'system-admin',
        subTab:['manage-projects','manage-publish-dist'],
        section:'manage-projects',
        apiList:[
            'createProjectDetails',
            'changeDeleteFlag',
            'checkIfBudgetPresentByProject',
        ]
    },
    {
        tab:'manage-projects',
        subTab:[],
        section:'manage-projects',
        apiList:[
            'createProjectDetails',
            'changeDeleteFlag',
            'checkIfBudgetPresentByProject',
        ]
    },
    {
        tab:'manage-publish-dist',
        subTab:[],
        section:'manage-publish-dist',
        apiList:[
            'checkRollbackStatus',
            'initiateWeekendingRollback',
            'initiateWeekendingRollForward',
            'getAllUserGroups',
            'getLastAccessedByReport',
            'revokePsrAccess',
            'getAllPublishedGroups',
            'publishWeeklyPSRReports',
            'revokePsrAccess',
        ]
    },
    {
        tab:'audit-logs',
        subTab:['publish-history','activity-tracker'],
        section:'publish-history',
        apiList:[
            'getPublishHistoryReport',
        ]
    },
    {
        tab:'publish-history',
        subTab:[],
        section:'publish-history',
        apiList:[
            'getPublishHistoryReport',
        ]
    },
    {
        tab:'activity-tracker',
        subTab:[],
        section:'activity-tracker',
        apiList:[
            'fetchAppAuditLogs',
        ]
    },
    {
        tab:'manage-release-date',
        subTab:[],
        section:'manage-release-date',
        apiList:[
            'getAllUnSynchedInterplanTitles',
            'updateViewFlagForInterplanTitles',
            'syncInterplanReleaseDateToPPSR',
        ]
    },

    {
        tab:'search',
        subTab:[],
        section:'search',
        apiList:[
            'searchTitleByParams',
        ]
    },

    {
        tab:'reports',
        subTab:[],
        section:'generate-report',
        apiList:[
            'generateAdHocPSRReport',
            'generateWeeklyVarianceReport',
            'generateMultiPPSRReport',
        ]
    },

    {
        tab:'home',
        subTab:[],
        section:'home',
        apiList:[
            'searchTitle',
        ]
    },

    {
        tab:'project',
        subTab:['status-report','weekly-variance','post-production'],
        section:'project',
        apiList:[
            'project',
            'saveProjectDetails',
            'updateProjectDetails',
            'initiateProjectStatusChangeover',
            'searchTitle',
            'getTalentsByProject',
            'saveTalentDetails',
            'getTitlesByProject',
            'saveProjectAka',
            'deleteProjectAkaById',
            'saveProductionEntity',
        ]
    },

    {
        tab:'status-report',
        subTab:['pre-production','production'],
        section:'status-report',
        apiList:[]
    },
    {
        tab:'pre-production',
        subTab:[],
        section:'pre-production',
        apiList:[
            'generateSingleReports',
            'headerTextByProjectIdAndWeekendingDt',
            'saveHeaderText',
            'keyIssuesNotesByProject',
            'saveKeyIssuesDetails',
            'saveTaxCredit',
            'scheduleLocationDataByProject',
            'saveLocationsDetails',
            'getPostProdSchedByProjectAndWeekendingDt',
            'savePostProductionDetails',
            'savePostProdSchedDetailsInKeyInfo',

            'preProdBudgetDetailsByProjectAndWeekEnding',
            'savePreProdDetails',
            'lockingBudgetandLocationDetails',
            'copyPostProductionSchedulesToActualsForWED',
        ]
    },
    {
        tab:'production',
        subTab:[],
        section:'production',
        apiList:[
            'generateSingleReports',
            'headerTextByProjectIdAndWeekendingDt',
            'saveHeaderText',
            'keyIssuesNotesByProject',
            'saveKeyIssuesDetails',
            'saveTaxCredit',
            'scheduleLocationDataByProject',
            'saveLocationsDetails',
            'getPostProdSchedByProjectAndWeekendingDt',
            'savePostProductionDetails',
            'savePostProdSchedDetailsInKeyInfo',

            'potentialDataByProject',
            'savePotentials',
            'deletePotentialById',
            'getTotalNetCostSummary',
            'saveChangePriorDetails',
            'saveCumulativeDetails',
            'deleteCumulativeById',
            'deleteChangePriorById',

            'budgetDataOnProjectAndWeekEnding',
            'saveBudgetDetails',
        ]
    },

    {
        tab:'weekly-variance',
        subTab:[],
        section:'weekly-variance',
        apiList:[
            'budgetDataOnProjectAndWeekEnding',
            'saveBudgetDetails',
            'potentialDataByProject',
            'savePotentials',
            'deletePotentialById',

            'weeklyVarianceDataByProjectAndWeekEnding',
            'getAllAccountData',
            'saveWeeklyVarianceDetails',
            'deleteWeeklyVarianceById',
        ]
    },

    {
        tab:'post-production',
        subTab:['key-info','schedule'],
        section:'post-production',
        apiList:[
            'generateSingleReports',
            'getVendors',
            'getTalents',
            'addPostProdTalent',
            'getProjectPostProdDetails',
            'getAllActivityList',
            'getPostProdActivitySched',
            'saveFilmDetailsAndPostFacility', //save post prod project
        ]
    },
    {
        tab:'key-info',
        subTab:[],
        section:'key-info',
        apiList:[
            'getPostStudioProduction',
            'savePostStudioProduction',
            'deletePpsrDealManagerById',
            'getCameraAndEditorLocationByProject',
            'saveCameraDetailsByProject',
            'deleteCameraDetailsById',
            'saveEditorialLocations',
            'deleteEditorialLocationById',
            'getRuntimeDetails',
            'getPostProdSchedDetailsInKeyInfo',
            'savePostProdSchedDetailsInKeyInfo',
            'updateFlagsByProjectAndWed',
            'getPostComments',
            'savePostComments',
        ]
    },
    {
        tab:'schedule',
        subTab:[],
        section:'schedule',
        apiList:[
            'savePostProdActivitySched',
            'getInterplanFeedForPPSR'
        ]
    },

]


export function filterApiErrorList(apiErrorList:ApiError[], error:any){
    let newError:ApiError|null=null;

    if(error && error.status==401)
        return apiErrorList;

    let activeTabs = getCurrentTabList();

    for(let a of ApiSecMapping){
        if(!activeTabs.includes(a.tab) || !a.apiList.length)
            continue;
        for(let l of a.apiList){
            if(error.url.includes(l) && error?.status>=400){
                newError={
                    api: l,
                    tab: a.tab,
                    section: a.section,
                    apiURL: error.url,
                    errorStatus: error?.error?.status??'',
                    errorStatusCode: error.status,
                    errorCode: "",
                    errorMessage: ""
                }
                if(newError.api=='publishWeeklyPSRReports' && newError.errorStatusCode==504){
                    console.error("PUBLISH PSR REPORT process returned 504 error");
                    return apiErrorList;
                }
                newError = setErrorMessage(newError);
                break;
            }
        }
        if(newError)    
            break;
    }
    

    if(newError){
        if(apiErrorList.length){
            if(newError.errorStatusCode>=500 || newError.errorStatusCode==401){
                apiErrorList.unshift(newError);
            }
            else{
                apiErrorList.push(newError)
            }
        }
        else{
            apiErrorList.push(newError);
        }
    }

    return apiErrorList;

}


function getCurrentTabList(){
    let tabList:string[]=['all'];
    let currentWindowURL= window.location.href;

    if(currentWindowURL.includes('/report/status-report/production')){
        tabList.push(...['project','status-report','production']);
    }
    else if(currentWindowURL.includes('/report/status-report/pre-production')){
        tabList.push(...['project','status-report','pre-production']);
    }
    else if(currentWindowURL.includes('/report/weekly-variance')){
        tabList.push(...['project','weekly-variance']);
    }
    else if(currentWindowURL.includes('/report/post-production/keyinfo')){
        tabList.push(...['project','post-production','keyinfo']);
    }
    else if(currentWindowURL.includes('/report/post-production/schedule')){
        tabList.push(...['project','post-production','schedule']);
    }
    else if(currentWindowURL.includes('/home')){
        tabList.push('home');
    }
    else if(currentWindowURL.includes('/search')){
        tabList.push('search');
    }
    else if(currentWindowURL.includes('/reports/preview')){
        tabList.push('reports');
    }
    else if(currentWindowURL.includes('/admin/system-admin/manage-projects')){
        tabList.push(...['admin','system-admin','manage-projects']);
    }
    else if(currentWindowURL.includes('/admin/system-admin/manage-publish-dist')){
        tabList.push(...['admin','system-admin','manage-publish-dist']);
    }
    else if(currentWindowURL.includes('/admin/audit-logs/psr-publish-history')){
        tabList.push(...['admin','audit-logs','publish-history']);
    }
    else if(currentWindowURL.includes('/admin/audit-logs/activity-tracker')){
        tabList.push(...['admin','audit-logs','activity-tracker']);
    }
    else if(currentWindowURL.includes('/admin/manage-release-date')){
        tabList.push(...['admin','manage-release-date']);
    }

    return tabList;
}


function setErrorMessage(error:ApiError){
    error.errorCode='(EMPG #'+ error.errorStatusCode.toString() +')';
    if(error.errorStatusCode>=500 || [401].includes(error.errorStatusCode)){
        error.errorMessage="Something went wrong. Please contact System Admin if issue persists " + error.errorCode;
    }
    else if(error.errorStatusCode>=400){
        error.errorMessage="Something went wrong " + error.errorCode;
    }

    return error;
}


export function removeApiError(errorList:ApiError[], tab:string):ApiError[]{

    if(!tab || !errorList.length)
        return errorList;
    
    for(let a of ApiSecMapping){
        if(a.tab==tab && !a.subTab.length){
            let newErrorList:ApiError[]=[];
            for(let e of errorList){
                if(!a.apiList.includes(e.api)){
                    newErrorList.push(e);
                }
            }
            errorList = newErrorList;
        }
        else if(a.tab==tab && a.subTab.length){
            for(let t of a.subTab){
                errorList = removeApiError(errorList,t);
            }
        }
    }

    errorList = sortErrorList(errorList);

    return errorList;

}


function sortErrorList(errorList:ApiError[]){
    let list:ApiError[]=[];
    let isthere401or500:Boolean=false
    for(let e of errorList){
        if((e.errorStatusCode>=500 || e.errorStatusCode==401) && !isthere401or500){
            isthere401or500=true;
            list.unshift(e);
        }
        else
            list.push(e);
    }

    return list;
}

